<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  data() {
    return {
    }
  },

}
</script>
<style lang="scss" type="text/scss">
.contact_beian {
  color: #fff;

  &:hover {
    color: #315efb;
  }
}

// 导航二级菜单
.el-menu--horizontal {
  .el-menu {
    .el-menu-item {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue